import { render, staticRenderFns } from "./TransferFund.vue?vue&type=template&id=2165b98a"
import script from "./TransferFund.vue?vue&type=script&lang=js"
export * from "./TransferFund.vue?vue&type=script&lang=js"
import style0 from "./TransferFund.vue?vue&type=style&index=0&id=2165b98a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports